module.exports = __webpack_public_path__ + "media/nuvola_high.e76a7707.mp4";